import React, {Component} from "react";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container} from "reactstrap";
import "../../_Content/css/feedback.css";

const idUsuario = localStorage.getItem("CodUsuario");

class Feedback extends Component {

	constructor(props) {
		super(props);

		this.state = {
			backdrop: true,
            isOpen: false,
			nome: '',
            email: '',
            mensagem: '',
			ecf: false,
			ecd: false,
			fiscal: false,
			contribuicoes: false,
			validarFormulario: false,
            showFormularioOpcional: false,
            exibirRetorno: false,
            mensagemRetorno: '',
            classeMensagemRetorno: 'valid-feedback text-center'
		};
    }
    
    beforeSubmit() {
        let enableSubmit;

        if (!this.state.showFormularioOpcional) {
            enableSubmit = 
                    ((this.state.fiscal || this.state.contribuicoes || this.state.ecf || this.state.ecd) ||
                    (this.state.fiscal && this.state.contribuicoes && this.state.ecf && this.state.ecd)) && this.state.mensagem !== '';

            this.setState({
                validarFormulario: enableSubmit
            });
        }
        else {
            enableSubmit = 
                    ((this.state.fiscal || this.state.contribuicoes || this.state.ecf || this.state.ecd) ||
                    (this.state.fiscal && this.state.contribuicoes && this.state.ecf && this.state.ecd)) && 
                    this.state.mensagem !== '' && this.state.nome !== '' && this.state.email !== '';

            this.setState({
                validarFormulario: enableSubmit
            });
        }      
    }

    readySubmit = () => {
        this.submitForm().then(retorno => {
            this.setState({ exibirRetorno: true });
                if(retorno.resposta) {
                    this.setState({ 
                        mensagemRetorno: 'Feedback enviado com sucesso!',
                        classeMensagemRetorno: "valid-feedback text-center" 
                    });
                }
                else {
                    this.setState({ 
                        mensagemRetorno: 'Não foi possível enviar seu feedback.',
                        classeMensagemRetorno: "invalid-feedback text-center" 
                    });
                }
            }
        );
    }

    submitForm = () => {
        return new Promise((resolve, reject) => {
            let data = new FormData();

            data.append("IDUSUARIO", idUsuario);
            data.append("MENSAGEM", this.state.mensagem);
            data.append("STRNOMEUSUARIO", this.state.nome);
            data.append("STREMAILUSUARIO", this.state.email);
            data.append("BOLFISCAL", this.state.fiscal);
            data.append("BOLCONTRIBUICOES", this.state.contribuicoes);
            data.append("BOLECF", this.state.ecf);
            data.append("BOLECD", this.state.ecd);

            HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Feedback/Salvar`, data, response => {
                resolve({resposta: response.data});
            }, () => { 
                this.setState({ 
                    exibirRetorno: true,
                    mensagemRetorno: 'Não foi possível enviar a mensagem.' 
                });
            });
        });
    }
    
	toggleModalFeedback = () => {
		this.setState({
            isOpen: !this.state.isOpen, 
            mensagemRetorno: '',
            exibirRetorno: false,
            classeMensagemRetorno: 'valid-feedback text-center'
		});	
	}

	handleFormData = (event) => {
		if (event.target.value.length > 0) {
            this.state.mensagem = event.target.value;
		}
		else {
            this.state.mensagem = '';
        }
        
        this.beforeSubmit();
    }
    
    handleCheckEcf = () => {
		if (!this.state.ecf) {
            this.state.ecf = true;
		}
		else {
            this.state.ecf = false;
        }
        
        this.beforeSubmit();
	}
    
    handleCheckEcd = () => {
		if (!this.state.ecd) {
            this.state.ecd = true;
		}
		else {
            this.state.ecd = false;
        }
        
        this.beforeSubmit();
	}

	handleCheckContribuicoes = () => {
		if (!this.state.contribuicoes) {
            this.state.contribuicoes = true;
		}
		else {
            this.state.contribuicoes = false;
        }
        
        this.beforeSubmit();
	}

	handleCheckFiscal = () => {
		if (!this.state.fiscal) {
            this.state.fiscal = true;
		}
		else {
            this.state.fiscal = false;
        }
        
        this.beforeSubmit();
    }
    
    handleNomeUsuario = event => {
        if (event.target.value.length > 0) {
            this.state.nome = event.target.value;
        }
        else {
            this.state.nome = '';
        }

        this.beforeSubmit();
    }

    handleEmailUsuario = event => {
        let regex = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
        if (regex.test(event.target.value)) {
            this.state.email = event.target.value;
        }
        else {
            this.state.email = '';
        }

        this.beforeSubmit();
    };

	handleFormOpcional = (event) => {
        this.setState({
            showFormularioOpcional: !this.state.showFormularioOpcional
		});
	}

	render() {
		let partialView;

		if (this.state.showFormularioOpcional) {
			partialView =
				<div className='showInputData'>
					<Row>
						<Col className='col-sm-6 col'>
							<input type='text' onChange={this.handleNomeUsuario} className='form-control' maxLength='150' placeholder='Nome'/>
						</Col>
						<Col className='col-sm-6 col'>
							<input type='text' onChange={this.handleEmailUsuario} className='form-control' maxLength='100' placeholder='E-mail'/>
						</Col>
					</Row>
				</div>
		}
		else {
			partialView = <div></div>
		}

		return (
			<Modal id='modalFeedback' isOpen={this.state.isOpen} className={this.props.className}>
				<ModalBody>
					<Container>
						<Row>
							<Col>
								<img src='/img/ecoicos/ecoico-feedback.svg' alt='erro'/>
								<label className='modalTitle'>Sua opinião é muito importante!</label>
							</Col>
						</Row>
						<Row>
							<Col>
								<label className='modalText'>
									Nos ajude a melhorar cada vez mais e realizar alterações relevantes para facilitar o
									seu dia-a-dia no uso dessa ferramenta. Escreva a baixo o seu comentário!
								</label>
							</Col>
						</Row>
						<Row>
							<Col>
								<label className='modulosText'>Escolha o(s) módulo(s) para feedback: </label>
								<input id='chkFiscal' className='checkModulos' type='checkbox'
								       onChange={this.handleCheckFiscal}/>
								<span className='checkText'>Fiscal</span>

								<input id='chkContribuicoes' className='checkModulos' type='checkbox'
								       onChange={this.handleCheckContribuicoes}/>
								<span className='checkText'>Contribuições</span>

                                <input id='chkEcf' className='checkModulos' type='checkbox'
								       onChange={this.handleCheckEcf}/>
								<span className='checkText'>ECF</span>
    						{/* Descomentar quando o projeto ECD entrar em produção */}
                                <input id='chkEcd' className='checkModulos' type='checkbox'
                                    onChange={this.handleCheckEcd}/>
                                <span className='checkText'>ECD</span>
							</Col>
						</Row>
						<Row>
							<Col>
                                <textarea className='msgFeedback' onChange={this.handleFormData} rows='5'
                                          maxLength='5000' placeholder='Digite aqui a sua sugestão'>
                                </textarea>
							</Col>
						</Row>
						<Row>
							<Col>
								<div className='float-right'>
									<input id='checkDadosUsuario' className='checkDadosUsuario' type='checkbox'
									       onChange={this.handleFormOpcional}/>
									<label className='rdbText'>Desejo incluir meus dados ao enviar o feedback</label>
								</div>
							</Col>
						</Row>
						<div>
							{partialView}
						</div>
                        {
                            this.state.exibirRetorno &&
                            <div className="row">
                                <span className={this.state.classeMensagemRetorno} style={{display: 'block'}}>{this.state.mensagemRetorno}</span>
                            </div>
                        }
						<Row>
							<Col>
								<div>
									<Button className={!this.state.validarFormulario ? 'float-right ecobtn fat cinza'  : 'float-right ecobtn fat vazado verde'} onClick={this.readySubmit} disabled={!this.state.validarFormulario}>Enviar</Button>
									<Button className='float-right ecobtn fat vazado vermelho' onClick={this.toggleModalFeedback}>Fechar</Button>
								</div>
							</Col>
						</Row>
					</Container>
				</ModalBody>
			</Modal>
		);
	}
}

export default Feedback;


// WEBPACK FOOTER //
// ./src/Componente/Feedback/Feedback.jsx